"use client";

import { Asset } from "@/services/assets/schema";
import { UserPreferences } from "@prisma/client";
import React from "react";

type Preferences = Pick<
  UserPreferences,
  "currency" | "language" | "darkMode" | "userId"
> & {
  asset: Asset;
};

const UserPreferencesContext = React.createContext<Preferences | null>(null);

interface UserPreferencesProviderProps {
  readonly children: React.ReactNode;
  readonly preferences: Preferences;
}

export function UserPreferencesProvider({
  children,
  preferences,
}: UserPreferencesProviderProps) {
  return (
    <UserPreferencesContext.Provider value={preferences}>
      {children}
    </UserPreferencesContext.Provider>
  );
}

export function useUserPreferences() {
  const context = React.useContext(UserPreferencesContext);
  if (context === null) {
    throw new Error(
      "useUserPreferences must be used within a UserPreferencesProvider",
    );
  }
  return context;
}

export function useUserCurrency() {
  const { currency } = useUserPreferences();
  return currency ?? "USD";
}

export function useUserAsset() {
  const { asset } = useUserPreferences();
  return asset;
}
